export interface Country {
    code: string; // ISO 3166-1 alpha-2
    name: string;
}

export const COUNTRIES: Country[] = [
    {
        name: 'Afghanistan',
        code: 'AF'
    },
    {
        name: 'Albania',
        code: 'AL'
    },
    {
        name: 'Algeria',
        code: 'DZ'
    },
    {
        name: 'American Samoa',
        code: 'AS'
    },
    {
        name: 'Andorra',
        code: 'AD'
    },
    {
        name: 'Angola',
        code: 'AO'
    },
    {
        name: 'Anguilla',
        code: 'AI'
    },
    {
        name: 'Antarctica',
        code: 'AQ'
    },
    {
        name: 'Antigua and Barbuda',
        code: 'AG'
    },
    {
        name: 'Argentina',
        code: 'AR'
    },
    {
        name: 'Armenia',
        code: 'AM'
    },
    {
        name: 'Aruba',
        code: 'AW'
    },
    {
        name: 'Australia',
        code: 'AU'
    },
    {
        name: 'Austria',
        code: 'AT'
    },
    {
        name: 'Azerbaijan',
        code: 'AZ'
    },
    {
        name: 'Bahamas',
        code: 'BS'
    },
    {
        name: 'Bahrain',
        code: 'BH'
    },
    {
        name: 'Bangladesh',
        code: 'BD'
    },
    {
        name: 'Barbados',
        code: 'BB'
    },
    {
        name: 'Belarus',
        code: 'BY'
    },
    {
        name: 'Belgium',
        code: 'BE'
    },
    {
        name: 'Belize',
        code: 'BZ'
    },
    {
        name: 'Benin',
        code: 'BJ'
    },
    {
        name: 'Bermuda',
        code: 'BM'
    },
    {
        name: 'Bhutan',
        code: 'BT'
    },
    {
        name: 'Bolivia, Plurinational State of',
        code: 'BO'
    },
    {
        name: 'Bonaire, Sint Eustatius and Saba',
        code: 'BQ'
    },
    {
        name: 'Bosnia and Herzegovina',
        code: 'BA'
    },
    {
        name: 'Botswana',
        code: 'BW'
    },
    {
        name: 'Bouvet Island',
        code: 'BV'
    },
    {
        name: 'Brazil',
        code: 'BR'
    },
    {
        name: 'British Indian Ocean Territory',
        code: 'IO'
    },
    {
        name: 'Brunei Darussalam',
        code: 'BN'
    },
    {
        name: 'Bulgaria',
        code: 'BG'
    },
    {
        name: 'Burkina Faso',
        code: 'BF'
    },
    {
        name: 'Burundi',
        code: 'BI'
    },
    {
        name: 'Cambodia',
        code: 'KH'
    },
    {
        name: 'Cameroon',
        code: 'CM'
    },
    {
        name: 'Canada',
        code: 'CA'
    },
    {
        name: 'Cape Verde',
        code: 'CV'
    },
    {
        name: 'Cayman Islands',
        code: 'KY'
    },
    {
        name: 'Central African Republic',
        code: 'CF'
    },
    {
        name: 'Chad',
        code: 'TD'
    },
    {
        name: 'Chile',
        code: 'CL'
    },
    {
        name: 'China',
        code: 'CN'
    },
    {
        name: 'Christmas Island',
        code: 'CX'
    },
    {
        name: 'Cocos (Keeling) Islands',
        code: 'CC'
    },
    {
        name: 'Colombia',
        code: 'CO'
    },
    {
        name: 'Comoros',
        code: 'KM'
    },
    {
        name: 'Congo',
        code: 'CG'
    },
    {
        name: 'Congo, the Democratic Republic of the',
        code: 'CD'
    },
    {
        name: 'Cook Islands',
        code: 'CK'
    },
    {
        name: 'Costa Rica',
        code: 'CR'
    },
    {
        name: 'Croatia',
        code: 'HR'
    },
    {
        name: 'Cuba',
        code: 'CU'
    },
    {
        name: 'Curaçao',
        code: 'CW'
    },
    {
        name: 'Cyprus',
        code: 'CY'
    },
    {
        name: 'Czech Republic',
        code: 'CZ'
    },
    {
        name: 'Côte d\'Ivoire',
        code: 'CI'
    },
    {
        name: 'Denmark',
        code: 'DK'
    },
    {
        name: 'Djibouti',
        code: 'DJ'
    },
    {
        name: 'Dominica',
        code: 'DM'
    },
    {
        name: 'Dominican Republic',
        code: 'DO'
    },
    {
        name: 'Ecuador',
        code: 'EC'
    },
    {
        name: 'Egypt',
        code: 'EG'
    },
    {
        name: 'El Salvador',
        code: 'SV'
    },
    {
        name: 'Equatorial Guinea',
        code: 'GQ'
    },
    {
        name: 'Eritrea',
        code: 'ER'
    },
    {
        name: 'Estonia',
        code: 'EE'
    },
    {
        name: 'Eswatini',
        code: 'SZ'
    },
    {
        name: 'Ethiopia',
        code: 'ET'
    },
    {
        name: 'Falkland Islands (Malvinas)',
        code: 'FK'
    },
    {
        name: 'Faroe Islands',
        code: 'FO'
    },
    {
        name: 'Fiji',
        code: 'FJ'
    },
    {
        name: 'Finland',
        code: 'FI'
    },
    {
        name: 'France',
        code: 'FR'
    },
    {
        name: 'French Guiana',
        code: 'GF'
    },
    {
        name: 'French Polynesia',
        code: 'PF'
    },
    {
        name: 'French Southern Territories',
        code: 'TF'
    },
    {
        name: 'Gabon',
        code: 'GA'
    },
    {
        name: 'Gambia',
        code: 'GM'
    },
    {
        name: 'Georgia',
        code: 'GE'
    },
    {
        name: 'Germany',
        code: 'DE'
    },
    {
        name: 'Ghana',
        code: 'GH'
    },
    {
        name: 'Gibraltar',
        code: 'GI'
    },
    {
        name: 'Greece',
        code: 'GR'
    },
    {
        name: 'Greenland',
        code: 'GL'
    },
    {
        name: 'Grenada',
        code: 'GD'
    },
    {
        name: 'Guadeloupe',
        code: 'GP'
    },
    {
        name: 'Guam',
        code: 'GU'
    },
    {
        name: 'Guatemala',
        code: 'GT'
    },
    {
        name: 'Guernsey',
        code: 'GG'
    },
    {
        name: 'Guinea',
        code: 'GN'
    },
    {
        name: 'Guinea-Bissau',
        code: 'GW'
    },
    {
        name: 'Guyana',
        code: 'GY'
    },
    {
        name: 'Haiti',
        code: 'HT'
    },
    {
        name: 'Heard Island and McDonald Islands',
        code: 'HM'
    },
    {
        name: 'Holy See (Vatican City State)',
        code: 'VA'
    },
    {
        name: 'Honduras',
        code: 'HN'
    },
    {
        name: 'Hong Kong',
        code: 'HK'
    },
    {
        name: 'Hungary',
        code: 'HU'
    },
    {
        name: 'Iceland',
        code: 'IS'
    },
    {
        name: 'India',
        code: 'IN'
    },
    {
        name: 'Indonesia',
        code: 'ID'
    },
    {
        name: 'Iran, Islamic Republic of',
        code: 'IR'
    },
    {
        name: 'Iraq',
        code: 'IQ'
    },
    {
        name: 'Ireland',
        code: 'IE'
    },
    {
        name: 'Isle of Man',
        code: 'IM'
    },
    {
        name: 'Israel',
        code: 'IL'
    },
    {
        name: 'Italy',
        code: 'IT'
    },
    {
        name: 'Jamaica',
        code: 'JM'
    },
    {
        name: 'Japan',
        code: 'JP'
    },
    {
        name: 'Jersey',
        code: 'JE'
    },
    {
        name: 'Jordan',
        code: 'JO'
    },
    {
        name: 'Kazakhstan',
        code: 'KZ'
    },
    {
        name: 'Kenya',
        code: 'KE'
    },
    {
        name: 'Kiribati',
        code: 'KI'
    },
    {
        name: 'Korea, Democratic People\'s Republic of',
        code: 'KP'
    },
    {
        name: 'Korea, Republic of',
        code: 'KR'
    },
    {
        name: 'Kuwait',
        code: 'KW'
    },
    {
        name: 'Kyrgyzstan',
        code: 'KG'
    },
    {
        name: 'Lao People\'s Democratic Republic',
        code: 'LA'
    },
    {
        name: 'Latvia',
        code: 'LV'
    },
    {
        name: 'Lebanon',
        code: 'LB'
    },
    {
        name: 'Lesotho',
        code: 'LS'
    },
    {
        name: 'Liberia',
        code: 'LR'
    },
    {
        name: 'Libya',
        code: 'LY'
    },
    {
        name: 'Liechtenstein',
        code: 'LI'
    },
    {
        name: 'Lithuania',
        code: 'LT'
    },
    {
        name: 'Luxembourg',
        code: 'LU'
    },
    {
        name: 'Macao',
        code: 'MO'
    },
    {
        name: 'Macedonia, the Former Yugoslav Republic of',
        code: 'MK'
    },
    {
        name: 'Madagascar',
        code: 'MG'
    },
    {
        name: 'Malawi',
        code: 'MW'
    },
    {
        name: 'Malaysia',
        code: 'MY'
    },
    {
        name: 'Maldives',
        code: 'MV'
    },
    {
        name: 'Mali',
        code: 'ML'
    },
    {
        name: 'Malta',
        code: 'MT'
    },
    {
        name: 'Marshall Islands',
        code: 'MH'
    },
    {
        name: 'Martinique',
        code: 'MQ'
    },
    {
        name: 'Mauritania',
        code: 'MR'
    },
    {
        name: 'Mauritius',
        code: 'MU'
    },
    {
        name: 'Mayotte',
        code: 'YT'
    },
    {
        name: 'Mexico',
        code: 'MX'
    },
    {
        name: 'Micronesia, Federated States of',
        code: 'FM'
    },
    {
        name: 'Moldova, Republic of',
        code: 'MD'
    },
    {
        name: 'Monaco',
        code: 'MC'
    },
    {
        name: 'Mongolia',
        code: 'MN'
    },
    {
        name: 'Montenegro',
        code: 'ME'
    },
    {
        name: 'Montserrat',
        code: 'MS'
    },
    {
        name: 'Morocco',
        code: 'MA'
    },
    {
        name: 'Mozambique',
        code: 'MZ'
    },
    {
        name: 'Myanmar',
        code: 'MM'
    },
    {
        name: 'Namibia',
        code: 'NA'
    },
    {
        name: 'Nauru',
        code: 'NR'
    },
    {
        name: 'Nepal',
        code: 'NP'
    },
    {
        name: 'Netherlands',
        code: 'NL'
    },
    {
        name: 'New Caledonia',
        code: 'NC'
    },
    {
        name: 'New Zealand',
        code: 'NZ'
    },
    {
        name: 'Nicaragua',
        code: 'NI'
    },
    {
        name: 'Niger',
        code: 'NE'
    },
    {
        name: 'Nigeria',
        code: 'NG'
    },
    {
        name: 'Niue',
        code: 'NU'
    },
    {
        name: 'Norfolk Island',
        code: 'NF'
    },
    {
        name: 'Northern Mariana Islands',
        code: 'MP'
    },
    {
        name: 'Norway',
        code: 'NO'
    },
    {
        name: 'Oman',
        code: 'OM'
    },
    {
        name: 'Pakistan',
        code: 'PK'
    },
    {
        name: 'Palau',
        code: 'PW'
    },
    {
        name: 'Palestine, State of',
        code: 'PS'
    },
    {
        name: 'Panama',
        code: 'PA'
    },
    {
        name: 'Papua New Guinea',
        code: 'PG'
    },
    {
        name: 'Paraguay',
        code: 'PY'
    },
    {
        name: 'Peru',
        code: 'PE'
    },
    {
        name: 'Philippines',
        code: 'PH'
    },
    {
        name: 'Pitcairn',
        code: 'PN'
    },
    {
        name: 'Poland',
        code: 'PL'
    },
    {
        name: 'Portugal',
        code: 'PT'
    },
    {
        name: 'Puerto Rico',
        code: 'PR'
    },
    {
        name: 'Qatar',
        code: 'QA'
    },
    {
        name: 'Romania',
        code: 'RO'
    },
    {
        name: 'Russian Federation',
        code: 'RU'
    },
    {
        name: 'Rwanda',
        code: 'RW'
    },
    {
        name: 'Réunion',
        code: 'RE'
    },
    {
        name: 'Saint Barthélemy',
        code: 'BL'
    },
    {
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        code: 'SH'
    },
    {
        name: 'Saint Kitts and Nevis',
        code: 'KN'
    },
    {
        name: 'Saint Lucia',
        code: 'LC'
    },
    {
        name: 'Saint Martin (French part)',
        code: 'MF'
    },
    {
        name: 'Saint Pierre and Miquelon',
        code: 'PM'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        code: 'VC'
    },
    {
        name: 'Samoa',
        code: 'WS'
    },
    {
        name: 'San Marino',
        code: 'SM'
    },
    {
        name: 'Sao Tome and Principe',
        code: 'ST'
    },
    {
        name: 'Saudi Arabia',
        code: 'SA'
    },
    {
        name: 'Senegal',
        code: 'SN'
    },
    {
        name: 'Serbia',
        code: 'RS'
    },
    {
        name: 'Seychelles',
        code: 'SC'
    },
    {
        name: 'Sierra Leone',
        code: 'SL'
    },
    {
        name: 'Singapore',
        code: 'SG'
    },
    {
        name: 'Sint Maarten (Dutch part)',
        code: 'SX'
    },
    {
        name: 'Slovakia',
        code: 'SK'
    },
    {
        name: 'Slovenia',
        code: 'SI'
    },
    {
        name: 'Solomon Islands',
        code: 'SB'
    },
    {
        name: 'Somalia',
        code: 'SO'
    },
    {
        name: 'South Africa',
        code: 'ZA'
    },
    {
        name: 'South Georgia and the South Sandwich Islands',
        code: 'GS'
    },
    {
        name: 'South Sudan',
        code: 'SS'
    },
    {
        name: 'Spain',
        code: 'ES'
    },
    {
        name: 'Sri Lanka',
        code: 'LK'
    },
    {
        name: 'Sudan',
        code: 'SD'
    },
    {
        name: 'Suriname',
        code: 'SR'
    },
    {
        name: 'Svalbard and Jan Mayen',
        code: 'SJ'
    },
    {
        name: 'Sweden',
        code: 'SE'
    },
    {
        name: 'Switzerland',
        code: 'CH'
    },
    {
        name: 'Syrian Arab Republic',
        code: 'SY'
    },
    {
        name: 'Taiwan, Province of China',
        code: 'TW'
    },
    {
        name: 'Tajikistan',
        code: 'TJ'
    },
    {
        name: 'Tanzania, United Republic of',
        code: 'TZ'
    },
    {
        name: 'Thailand',
        code: 'TH'
    },
    {
        name: 'Timor-Leste',
        code: 'TL'
    },
    {
        name: 'Togo',
        code: 'TG'
    },
    {
        name: 'Tokelau',
        code: 'TK'
    },
    {
        name: 'Tonga',
        code: 'TO'
    },
    {
        name: 'Trinidad and Tobago',
        code: 'TT'
    },
    {
        name: 'Tunisia',
        code: 'TN'
    },
    {
        name: 'Turkey',
        code: 'TR'
    },
    {
        name: 'Turkmenistan',
        code: 'TM'
    },
    {
        name: 'Turks and Caicos Islands',
        code: 'TC'
    },
    {
        name: 'Tuvalu',
        code: 'TV'
    },
    {
        name: 'Uganda',
        code: 'UG'
    },
    {
        name: 'Ukraine',
        code: 'UA'
    },
    {
        name: 'United Arab Emirates',
        code: 'AE'
    },
    {
        name: 'United Kingdom',
        code: 'GB'
    },
    {
        name: 'United States',
        code: 'US'
    },
    {
        name: 'United States Minor Outlying Islands',
        code: 'UM'
    },
    {
        name: 'Uruguay',
        code: 'UY'
    },
    {
        name: 'Uzbekistan',
        code: 'UZ'
    },
    {
        name: 'Vanuatu',
        code: 'VU'
    },
    {
        name: 'Venezuela, Bolivarian Republic of',
        code: 'VE'
    },
    {
        name: 'Viet Nam',
        code: 'VN'
    },
    {
        name: 'Virgin Islands, British',
        code: 'VG'
    },
    {
        name: 'Virgin Islands, U.S.',
        code: 'VI'
    },
    {
        name: 'Wallis and Futuna',
        code: 'WF'
    },
    {
        name: 'Western Sahara',
        code: 'EH'
    },
    {
        name: 'Yemen',
        code: 'YE'
    },
    {
        name: 'Zambia',
        code: 'ZM'
    },
    {
        name: 'Zimbabwe',
        code: 'ZW'
    },
    {
        name: 'Åland Islands',
        code: 'AX'
    }
];

export const LOCALIZATIONS: { [lang: string]: { [code: string]: string } } = {
    it: {
        IT: 'Italia',
        AF: 'Afghanistan',
        AL: 'Albania',
        DZ: 'Algeria',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua and Barbuda',
        AN: 'Antille Olandesi',
        SA: 'Arabia Saudita',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgio',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnia Erzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brasile',
        IO: 'British Indian Ocean T.',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        MM: 'Myanmar',
        BI: 'Burundi',
        KH: 'Cambogia',
        CM: 'Camerun',
        CA: 'Canada',
        CV: 'Capo Verde',
        CZ: 'Repubblica Ceca',
        CX: 'Christmas Island',
        TD: 'Ciad',
        CL: 'Cile',
        CN: 'Cina',
        CY: 'Cipro',
        VA: 'Città del Vaticano',
        CC: 'Cocos Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CK: 'Cook Islands',
        KP: 'Corea',
        CI: 'Costa d\'Avorio',
        CR: 'Costa Rica',
        HR: 'Croazia',
        CU: 'Cuba',
        DK: 'Danimarca',
        DM: 'Dominica',
        TL: 'East Timor',
        EC: 'Ecuador',
        EG: 'Egitto',
        SV: 'El Salvador',
        AE: 'Emirati Arabi Uniti',
        ER: 'Eritrea',
        XX: 'Estero',
        EE: 'Estonia',
        ET: 'Etiopia',
        FK: 'Falkland Islands',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        PH: 'Filippine',
        FI: 'Finlandia',
        FX: 'France, Metropolitan',
        FR: 'Francia',
        TF: 'French Southern Tr.',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        DE: 'Germania',
        GH: 'Ghana',
        JM: 'Giamaica',
        JP: 'Giappone',
        GI: 'Gibilterra',
        DJ: 'Gibuti',
        JO: 'Giordania',
        GB: 'Regno Unito',
        GR: 'Grecia',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadalupa',
        GU: 'Guam',
        GT: 'Guatemala',
        GF: 'Guiana Francese',
        GN: 'Guinea',
        GQ: 'Guinea Equatoriale',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard Island',
        HN: 'Honduras',
        HK: 'Hong Kong',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran',
        IQ: 'Iraq',
        IE: 'Irlanda',
        IS: 'Islanda',
        KY: 'Isole Cayman',
        SB: 'Isole Solomon',
        VG: 'Isole Vergini (GB)',
        VI: 'Isole Vergini (USA)',
        IL: 'Israele',
        YU: 'Jugoslavia',
        KZ: 'Kazakistan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: 'Lao People\'s Rp.',
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libia',
        LI: 'Liechtenstein',
        LT: 'Lituania',
        LU: 'Lussemburgo',
        MO: 'Macao',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldive',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Marocco',
        MH: 'Marshall Islands',
        MQ: 'Martinica',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Messico',
        FM: 'Micronesia',
        MD: 'Moldova',
        MN: 'Mongolia',
        MS: 'Montserrat',
        MZ: 'Mozambico',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NT: 'Neutral Zone',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MP: 'Northern Mariana Islands',
        NO: 'Norvegia',
        NC: 'Nuova Caledonia',
        NZ: 'Nuova Zelanda',
        NL: 'Olanda',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papua Nuova Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PN: 'Pitcairn',
        PF: 'Polinesia Francese',
        PL: 'Polonia',
        PR: 'Porto Rico',
        PT: 'Portogallo',
        MC: 'Principato di Monaco',
        QA: 'Qatar',
        CF: 'Repubblica Centrafricana',
        CD: 'Repubblica Democratica del Congo',
        KR: 'Repubblica di Corea',
        DO: 'Repubblica Dominicana',
        RE: 'Reunion',
        RO: 'Romania',
        RW: 'Ruanda',
        RU: 'Russia',
        EH: 'Sahara Occidentale',
        SH: 'Saint Helena',
        KN: 'Saint Kitts and Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint Pierre and Miquelon',
        VC: 'Saint Vincent & Grenadines',
        WS: 'Samoa',
        AS: 'Samoa Americane',
        SM: 'San Marino',
        ST: 'Sao Tome and Principe',
        SN: 'Senegal',
        CS: 'Serbia and Montenegro',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SY: 'Siria',
        SK: 'Slovacchia',
        SI: 'Slovenia',
        SO: 'Somalia',
        GS: 'South Georgia and the SSI',
        ES: 'Spagna',
        LK: 'Sri Lanka',
        US: 'Stati Uniti d\'America',
        ZA: 'Sud Africa',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard and Jan Mayen',
        SE: 'Svezia',
        CH: 'Svizzera',
        SZ: 'Swaziland',
        TJ: 'Tagikistan',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        TH: 'Thailandia',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad e Tobago',
        TN: 'Tunisia',
        TR: 'Turchia',
        TM: 'Turkmenistan',
        TC: 'Turks and Caicos Islands',
        TV: 'Tuvalu',
        UA: 'Ucraina',
        UG: 'Uganda',
        HU: 'Ungheria',
        UY: 'Uruguay',
        UM: 'US Minor Outlying Islands',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        WF: 'Wallis and Futuna',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe'
    }
};

// @see: https://datahub.io/core/country-list
